import { render, staticRenderFns } from "./vertical-steps.vue?vue&type=template&id=736ba820&scoped=true"
import script from "./vertical-steps.vue?vue&type=script&lang=js"
export * from "./vertical-steps.vue?vue&type=script&lang=js"
import style0 from "./vertical-steps.vue?vue&type=style&index=0&id=736ba820&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ba820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736ba820')) {
      api.createRecord('736ba820', component.options)
    } else {
      api.reload('736ba820', component.options)
    }
    module.hot.accept("./vertical-steps.vue?vue&type=template&id=736ba820&scoped=true", function () {
      api.rerender('736ba820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vertical-steps.vue"
export default component.exports